import {ResolveFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {CustomComponentService} from "../../../../tramitantes/src/app/services/custom-component.service";
import {ICustomComponent, IIdCompuestoVersion} from "../../../../tramitantes/src/app/shared/interfaces/configuracion";
import {catchError, EMPTY, Observable, of} from "rxjs";

export const customComponentsResolver: ResolveFn<any> = (route): Observable<ICustomComponent | null> => {
  const customComponentService = inject(CustomComponentService);
  const router = inject(Router);
  const navegacion = router.getCurrentNavigation();
  const id: IIdCompuestoVersion  | null =  navegacion?.extras.state?.['data'];
  if (!id || !id.id || !id.version) return of(null);
  return customComponentService.getComponentById(id.id, id.version)
    .pipe(
      catchError(() => {
        router.navigate(['/not-found']).then();
        return EMPTY;
      }))
};
